import styled from "@emotion/styled";
import type { ItemListOtherRowData } from "@/components/item-list/types/item-list-row-types";

export const ItemListOtherRow = ({ data }: { data: ItemListOtherRowData }) => {
  const minHeightPx = data.payload.minHeightPx ?? 60;

  return <Wrapper $minHeightPx={minHeightPx}>{data.payload.children}</Wrapper>;
};

const Wrapper = styled.div<{ $minHeightPx: number }>`
  min-height: ${({ $minHeightPx }) => $minHeightPx}px;
`;
